/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpPrestigeActionRequest
 */
export interface FuelUpPrestigeActionRequest {
    /**
     * Prestige action to perform
     * @type {string}
     * @memberof FuelUpPrestigeActionRequest
     */
    action: FuelUpPrestigeActionRequestActionEnum;
    /**
     * Target prestige level (for prestige action)
     * @type {number}
     * @memberof FuelUpPrestigeActionRequest
     */
    targetLevel?: number;
    /**
     * Bonus ID to activate/deactivate
     * @type {string}
     * @memberof FuelUpPrestigeActionRequest
     */
    bonusId?: string;
}


/**
 * @export
 */
export const FuelUpPrestigeActionRequestActionEnum = {
    prestige: 'prestige',
    activate_bonus: 'activate_bonus',
    deactivate_bonus: 'deactivate_bonus'
} as const;
export type FuelUpPrestigeActionRequestActionEnum = typeof FuelUpPrestigeActionRequestActionEnum[keyof typeof FuelUpPrestigeActionRequestActionEnum];


/**
 * Check if a given object implements the FuelUpPrestigeActionRequest interface.
 */
export function instanceOfFuelUpPrestigeActionRequest(value: object): value is FuelUpPrestigeActionRequest {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function FuelUpPrestigeActionRequestFromJSON(json: any): FuelUpPrestigeActionRequest {
    return FuelUpPrestigeActionRequestFromJSONTyped(json, false);
}

export function FuelUpPrestigeActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpPrestigeActionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'targetLevel': json['targetLevel'] == null ? undefined : json['targetLevel'],
        'bonusId': json['bonusId'] == null ? undefined : json['bonusId'],
    };
}

export function FuelUpPrestigeActionRequestToJSON(json: any): FuelUpPrestigeActionRequest {
    return FuelUpPrestigeActionRequestToJSONTyped(json, false);
}

export function FuelUpPrestigeActionRequestToJSONTyped(value?: FuelUpPrestigeActionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'targetLevel': value['targetLevel'],
        'bonusId': value['bonusId'],
    };
}

